define(function(require) {
    var _ = require('underscore');
    var $ = require('j');

    var originalOnFunction = $.fn.on;
    var originalOneFunction = $.fn.one;
    var originalTriggerFunction = $.fn.trigger;

    var tapOnClickReplacer = function(str) {
        return str.replace(/((^|\s)+tap)/, '$2click');
    };

    //Delegate "tap" event handlers to "click" handlers
    _.extend($.fn, {
        on: function() {
            var args = [].slice.call(arguments);
            args[0] = tapOnClickReplacer(args[0]);

            return originalOnFunction.apply(this, args);
        },
        one: function() {
            var args = [].slice.call(arguments);
            args[0] = tapOnClickReplacer(args[0]);

            return originalOneFunction.apply(this, args);
        },
        trigger: function() {
            var args = [].slice.call(arguments);
            if (typeof args[0] === 'string') {
                args[0] = tapOnClickReplacer(args[0]);
            }

            return originalTriggerFunction.apply(this, args);
        }
    });

    // Add listeners for tapHover and tapRemoveHover events
    var startCoordinates = {
        x: 0,
        y: 0
    };
    var originTarget;
    var isTouchHappening;

    var dispatchEvent = function(target, eventName) {
        target && target.dispatchEvent && target.dispatchEvent($.Event(eventName));
    };

    document.body.addEventListener('touchstart', function(e) {
        if (e.touches.length > 1) {
            return;
        }

        var firstFingerTouch = e.changedTouches ? e.changedTouches[0] : e;
        startCoordinates.x = firstFingerTouch.pageX;
        startCoordinates.y = firstFingerTouch.pageY;

        originTarget = e.target;

        isTouchHappening = true;
        dispatchEvent(originTarget, 'tapHover');
    });

    document.body.addEventListener('touchmove', function(e) {
        var firstFingerTouch = e.changedTouches ? e.changedTouches[0] : e;
        var touchMovementDelta = {
            x: Math.abs(startCoordinates.x - firstFingerTouch.pageX),
            y: Math.abs(startCoordinates.y - firstFingerTouch.pageY)
        };
        var isSwiped = touchMovementDelta.x > 10 || touchMovementDelta.y > 10;

        if (isTouchHappening && isSwiped) {
            isTouchHappening = false;
            dispatchEvent(originTarget, 'tapRemoveHover');
        }
    });

    ['touchcancel', 'touchend'].forEach(function(eventName) {
        document.body.addEventListener(eventName, function() {
            if (isTouchHappening) {
                isTouchHappening = false;
                dispatchEvent(originTarget, 'tapRemoveHover');
            }
        });
    });

});
